import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const LINKED_DOCUMENT_SCHEMA = Object.freeze({
  DATE_ADDED: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ),
  ID: '',
  TYPE: '', // documentType as string
});
export const RECORD = generateSchema(LINKED_DOCUMENT_SCHEMA);
export const KEYS: any = generateKeys(LINKED_DOCUMENT_SCHEMA);

export class LinkedDocument extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get dateAdded(): string {
    return this.get(KEYS.DATE_ADDED);
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }
}
